import { WHEN_BLOCK, METHODS } from 'constants/MeshbotConstant';

import { buildUserField } from './buildUserField';

/**
 * Builds the isUserLockOperation when-block for the capabilityDynamicFields-driven flow (shared by all value types
 * of this method, e.g. keypad user_code_action and door lock user_lock_operation) — the clean format WITHOUT
 * blockMeta. The edit flow reconstructs everything from `fields`, so blockMeta is not stored.
 * Returns {} when the action is not selected yet (incomplete trigger stays invalid until filled).
 * @param {Object} ruleTrigger - trigger from the store
 * @returns {Object} when-block or {}
 */
export const generateUserLockOperationWhenBlock = (ruleTrigger) => {
    const dynamicFields = ruleTrigger.capabilityDynamicFields || {};

    if (!dynamicFields.stateFieldValue) {
        return {};
    }

    return {
        blockType: WHEN_BLOCK.BLOCK_TYPE_WHEN,
        blockOptions: {
            method: {
                name: METHODS.IS_USER_LOCK_OPERATION,
                args: {
                    item: WHEN_BLOCK.ITEM,
                    state: WHEN_BLOCK.STATE,
                    user: WHEN_BLOCK.USER,
                },
            },
        },
        fields: [
            {
                name: WHEN_BLOCK.ITEM,
                type: WHEN_BLOCK.ITEM,
                value: ruleTrigger.selectedCapability?._id,
            },
            {
                name: WHEN_BLOCK.STATE,
                type: WHEN_BLOCK.TYPE.TOKEN,
                value: dynamicFields.stateFieldValue,
            },
            buildUserField(dynamicFields),
        ],
    };
};
